import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CouponService } from 'app/core/services/coupon.service';
import { CommonService } from 'app/shared/services/common.service';
import { MessageService } from 'primeng/api';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { Observable } from 'rxjs';
import { AdvMessageService } from 'app/shared/services/message.service';
import { CouponStatus } from 'app/core/model/enums/status-enum';
@Component({
  selector: 'app-coupon-redemption',
  templateUrl: './coupon-redemption.component.html',
  styleUrls: ['./coupon-redemption.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class CouponRedemptionComponent implements OnInit {
  couponNum
  couponDetails
  CouponStatus = CouponStatus;
  statusList$: Observable<{ label: string, value: any }[]>;
  isRelized = true
  businessId
  isShow = false
  constructor(private commonService: CommonService, private couponService: CouponService, private messageService: AdvMessageService,
    private localizationService: LocalizationService,private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('COUPON.TITLE'));
    this.statusList$ = this.localizationService.getEnumValuesTranslation(CouponStatus);
  }
  searchCoupon() {
    if (!this.couponNum) {
      this.messageService.errorMessage('COUPON.ENTER_COUPON_NUM')
      return
    }
    this.couponService.getCoupon(this.couponNum).subscribe((res: any) => {
      if (!res) {
        this.messageService.errorMessage('COUPON.NOT_EXIST',true)
      }
      else {
        this.isShow = true;
        this.couponDetails = res;
        this.cdr.markForCheck();
        this.isRelized = this.couponDetails.Status != CouponStatus.notRealized
      }
    });
  }
  implementCoupon() {
    if (this.couponDetails.Status === CouponStatus.notRealized) {
      this.couponService.implementCoupon(this.couponNum).subscribe((res: any) => {
        this.messageService.successMessage('GENERAL.MESSAGES.DATA_SAVED_SCCESSFULLY', true)
        this.isRelized=true;
        this.searchCoupon();
      });
    }
  }
  ngOnDestroy() {
    this.commonService.clearCurrentPageHeader();
  }
}
